export default {
    'between': 'between',
    'contains': 'contains',
    'endsWith': 'ends_with',
    'equals': 'equals',
    'matchAllOf': 'match_all_of',
    'matchOneOf': 'match_one_of',
    'near': 'near',
    'range': 'range',
    'startsWith': 'starts_with',
};



// WEBPACK FOOTER //
// ./src/components/list/Filters/filterMatchTypes.js